// UpdateLogPage - Changelog/update log page for ContentOS 3
import React from 'react';
import { Calendar } from 'lucide-react';

const UpdateLogPage = () => {
    const logs = [
        {
            version: "v1.0.0",
            date: "2026-02-07",
            changes: [
                "ContentOS 3 全新发布",
                "AI 内容创作流程：选 Skill -> 输入主题 -> 生成大纲 -> 生成图片",
                "多平台排版：小红书、微信公众号一键格式化",
                "热点追踪：微博、小红书、抖音、微信实时热点",
                "RSS 订阅：聚合内容灵感源",
                "Skill 模板系统：内置 + 自定义模板",
                "内容历史管理",
                "积分系统与充值"
            ]
        }
    ];

    return (
        <div className="w-full min-h-full bg-white p-10 animate-in fade-in duration-500">
            <div className="max-w-4xl mx-auto">
                <div className="mb-12 text-center">
                    <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-2">
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">更新日志</span>
                    </h1>
                    <p className="text-gray-500">持续进化，为您带来更好的创作体验</p>
                </div>

                <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent">
                    {logs.map((log, index) => (
                        <div key={index} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active">
                            <div className="flex items-center justify-center w-10 h-10 rounded-full border border-white bg-slate-100 group-[.is-active]:bg-blue-500 text-slate-500 group-[.is-active]:text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10">
                                <Calendar className="w-5 h-5" />
                            </div>

                            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                                <div className="flex items-center justify-between mb-3">
                                    <span className="font-black text-lg text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">{log.version}</span>
                                    <time className="font-medium text-xs text-slate-400">{log.date}</time>
                                </div>
                                <ul className="space-y-2">
                                    {log.changes.map((change, i) => (
                                        <li key={i} className="flex items-start text-sm text-slate-600">
                                            <span className="mr-2 mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-400 shrink-0"></span>
                                            {change}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UpdateLogPage;
